export default {
  staticMedia: [],
  staticMediaLoading: false,
}